export const crm = {
  it: {
    navigation: {
      brand: 'Sales Navigator',
      contacts: 'Contatti',
      leads: 'Lead',
      prospezione: 'Prospezione',
      navigator: 'Navigatore',
      appointments: 'Appuntamenti',
      reports: 'Report',
      settings: 'Impostazioni · Utenti',
      logout: 'Esci'
    },
    common: {
      loading: 'Caricamento…',
      searchPlaceholder: 'Cerca nome/email/telefono',
      filterSource: 'Sorgente',
      filterTag: 'Tag',
      filterStage: 'Tipo',
      sortRecent: 'Più recenti',
      sortName: 'Ordina per nome',
      buttons: {
        new: 'Nuovo',
        create: 'Crea',
        save: 'Salva',
        edit: 'Modifica',
        delete: 'Elimina',
        cancel: 'Annulla',
        close: 'Chiudi',
        open: 'Apri'
      },
      stages: {
        contact: 'Contatto',
        lead: 'Lead',
        client: 'Cliente'
      },
      relative: {
        today: 'oggi',
        yesterday: 'ieri',
        daysAgo: '{{count}}g fa'
      },
      openLeadBadge: '{{count}} lead',
      selected: '{{count}} selezionati'
    },
    contacts: {
      title: 'Contatti',
      subtitle: 'Gestisci la rubrica e verifica attività e duplicati.',
      newButton: 'Nuovo contatto',
      summary: '{{count}} risultati · duplicati email: {{duplicateEmails}} · duplicati telefono: {{duplicatePhones}}',
      columns: {
        name: 'Nome',
        company: 'Ragione Sociale',
        email: 'Email',
        phone: 'Telefono',
        source: 'Origine',
        stage: 'Tipo',
        address: 'Indirizzo',
        city: 'Città',
        prospectStatus: 'Status Prospezione',
        leadStatus: 'Status Lead',
        tags: 'Tag',
        interest_level: 'Livello Interesse',
        route_index: 'Indice Percorso',
        vat: 'P.IVA',
        rank: 'Rank',
        lastActivity: 'Ultima attività',
        website: 'Website',
        googleMaps: 'Google Maps',
        actions: 'Azioni'
      },
      noTag: '—',
      noRank: 'Non assegnato',
      duplicateBadge: 'dup',
      addToNavigator: 'Aggiungi al Navigatore',
      alreadyInNavigator: 'Già nel Navigatore',
      addedToNavigator: 'Contatto aggiunto al Navigatore',
      drawer: {
        newTitle: 'Nuovo contatto',
        editTitle: 'Modifica contatto',
        fullName: 'Nome completo',
        email: 'Email',
        phone: 'Telefono',
        source: 'Origine',
        tags: 'Tag (separati da virgola)',
        vat: 'Partita IVA',
        rank: 'Rank cliente',
        rankPlaceholder: 'Non assegnato',
        stage: 'Tipo',
        typeLabel: 'Tipo',
        leadStatusLabel: 'Status Lead',
        prospectStatusLabel: 'Status Prospezione',
        contactTypeOption: 'Contatto',
        leadTypeOption: 'Lead',
        prospectTypeOption: 'Prospect'
      },
      delete: {
        title: 'Elimina contatto',
        message: 'Sei sicuro di voler eliminare {{name}}? L’operazione non è reversibile.',
        confirm: 'Elimina',
        cancel: 'Annulla'
      }
    },
    leads: {
      title: 'Lead',
      subtitle: 'Monitora pipeline, metriche e attività.',
      newLead: 'Nuovo lead',
      na: 'N/D',
      searchPlaceholder: 'Cerca per titolo o contatto',
      filters: {
        stage: 'Stage',
        duplicates: 'Possibili duplicati'
      },
      defaults: {
        untitled: 'Lead senza titolo',
        fallbackTitle: 'Lead',
        noName: 'Senza nome',
        linkedContact: 'Contatto collegato'
      },
      kpi: {
        totalContacts: 'Contatti totali',
        totalLeads: 'Lead totali',
        scheduled: 'Appuntamenti programmati',
        completed: 'Appuntamenti conclusi',
        noShow: 'Assenze',
        conversion: 'Tasso di conversione',
        conversionDetail: '{{won}} vinti su {{total}}'
      },
      pipelineSummary: 'Distribuiti: {{breakdown}}',
      kpiSummary: 'Completati: {{completed}} · No-show: {{noShow}}',
      pipeline: {
        headings: {
          new: 'Nuovi',
          qualified: 'Qualificati',
          scheduled: 'Schedulati',
          won: 'Vinti',
          lost: 'Persi'
        },
        empty: 'Trascina qui i lead per aggiornarne lo stato',
        staleBadge: 'da follow-up',
        duplicateBadge: 'dup',
        duplicateMessage: 'Contatto duplicato nel funnel',
        unassigned: 'Contatto non associato',
        lastUpdate: 'Ultimo update',
        source: 'Origine',
        emptyColumn: 'Nessun lead in questa colonna.'
      },
      followUps: {
        title: 'Follow-up da fare',
        empty: 'Tutto aggiornato!'
      },
      modal: {
        newTitle: 'Nuovo lead',
        editTitle: 'Modifica lead',
        titleLabel: 'Titolo',
        valueLabel: 'Valore (EUR)',
        stageLabel: 'Stage',
        selectContact: 'Seleziona contatto',
        newContactHeading: 'Crea nuovo contatto',
        contactName: 'Nome',
        contactPhone: 'Telefono',
        contactEmail: 'Email',
        notes: 'Note interne',
        notesPlaceholder: 'Aggiungi note, dettagli o informazioni rilevanti sul lead...',
        attachedContact: 'Contatto collegato',
        addLead: 'Crea lead',
        saveLead: 'Salva',
        cancel: 'Annulla',
        deleteTitle: 'Elimina lead',
        deleteText: 'Vuoi davvero eliminare {{title}}? L\'azione è irreversibile.',
        details: 'Dettagli',
        linkContact: 'Collega contatto',
        singleMode: 'Modalità singolo',
        multiMode: 'Modalità multipla',
        contactDetailsNote: 'I dettagli del contatto si modificano dalla scheda contatto.',
        orCreateNew: '…oppure crea un nuovo contatto',
        remove: 'Rimuovi',
        loading: 'Caricamento…',
        selected: 'selezionati'
      }
    },
    appointments: {
      title: 'Agenda e appuntamenti',
      subtitle: 'Scheduling & Appointments',
      description: 'Gestisci slot, prenotazioni e promemoria automatici.',
      calendarSync: {
        title: 'Sincronizzazione calendario',
        heading: 'Connetti il tuo calendario',
        description: 'Salva il link del calendario (ICS o CalDAV) per mantenere gli appuntamenti Launch allineati con il tuo programma personale.',
        status: 'Stato',
        edit: 'Modifica',
        displayName: 'Nome visualizzato',
        displayNamePlaceholder: 'es. Victor – Outlook',
        provider: 'Provider',
        providerManual: 'Manuale (link ICS)',
        providerMicrosoft: 'Microsoft 365',
        providerCalendly: 'Calendly',
        icsLink: 'Link ICS / prenotazione',
        icsLinkPlaceholder: 'https://...',
        saveConnection: 'Salva connessione'
      },
      buildAvailability: {
        title: 'Crea disponibilità',
        description: 'Aggiungi slot temporali che il sistema può prenotare automaticamente quando i lead scelgono un orario.',
        startDateTime: 'Data e ora di inizio',
        duration: 'Durata (minuti)',
        calendar: 'Calendario',
        internalNotes: 'Note interne',
        internalNotesPlaceholder: 'Dettagli opzionali per il team',
        addSlot: 'Aggiungi slot'
      },
      availableSlots: {
        title: 'Slot disponibili',
        subtitle: 'Pronti per la prenotazione',
        empty: 'Nessuna disponibilità ancora. Aggiungi uno slot a sinistra per rendere disponibili le finestre di prenotazione.',
        open: '{{count}} aperti',
        book: 'Prenota',
        cancel: 'Annulla'
      },
      bookedSlots: {
        title: 'Slot prenotati'
      },
      upcoming: {
        title: 'Prossimi appuntamenti',
        subtitle: 'Prossimi 20 appuntamenti',
        scheduled: '{{count}} programmati',
        empty: 'Quando uno slot disponibile viene prenotato, apparirà qui con i dettagli del contatto e lo stato.',
        when: 'Quando',
        contact: 'Contatto',
        subject: 'Titolo',
        status: 'Stato',
        actions: 'Azioni',
        join: 'Partecipa',
        done: 'Completato',
        cancel: 'Annulla'
      },
      modal: {
        bookTitle: 'Prenota slot',
        existingContact: 'Contatto esistente',
        selectContact: 'Seleziona contatto…',
        orCreateNew: 'Oppure crea nuovo',
        fullName: 'Nome completo',
        phone: 'Telefono',
        phonePlaceholder: '+39 333…',
        email: 'Email (opzionale)',
        emailPlaceholder: 'client@example.com',
        title: 'Titolo',
        titlePlaceholder: 'Chiamata di consulenza',
        notes: 'Note',
        notesPlaceholder: 'Agenda breve',
        cancel: 'Annulla',
        confirmBooking: 'Conferma prenotazione'
      },
      errors: {
        loadData: 'Impossibile caricare i dati di pianificazione',
        createSlot: 'Impossibile creare lo slot',
        cancelSlot: 'Impossibile annullare lo slot',
        bookAppointment: 'Impossibile prenotare l\'appuntamento',
        updateAppointment: 'Impossibile aggiornare l\'appuntamento',
        deleteAppointment: 'Impossibile eliminare l\'appuntamento',
        deleteSlot: 'Impossibile eliminare lo slot',
        saveConnection: 'Impossibile salvare la connessione del calendario',
        selectContact: 'Seleziona un contatto esistente o fornisci i dettagli per uno nuovo.',
        contactCreationFailed: 'Creazione contatto fallita'
      },
      loading: 'Caricamento dati di pianificazione…',
      delete: {
        title: 'Elimina appuntamento',
        confirm: 'Sei sicuro di voler eliminare questo appuntamento? Questa azione non può essere annullata.',
        button: 'Elimina'
      },
      deleteSlot: {
        title: 'Elimina slot',
        confirm: 'Sei sicuro di voler eliminare questo slot prenotato? Verrà eliminato anche l\'appuntamento associato se presente. Questa azione non può essere annullata.'
      }
    },
    reports: {
      title: 'Report',
      subtitle: 'Panoramica KPI e trend delle conversazioni.',
      loading: 'Caricamento metriche…',
      empty: 'Nessun dato KPI disponibile ancora. Le interazioni catturate tramite WhatsApp, contatti e appuntamenti appariranno qui automaticamente.',
      cards: {
        inboundMessages: 'Messaggi in ingresso',
        contactsCaptured: 'Contatti acquisiti',
        leadsCreated: 'Lead creati',
        appointmentsCompleted: 'Appuntamenti completati',
        avgFirstResponse: 'Tempo medio prima risposta',
        vsPrevious: 'vs precedente'
      },
      charts: {
        messagingVolume: 'Volume messaggi',
        pipelineVelocity: 'Velocità pipeline'
      },
      table: {
        date: 'Data',
        period: 'Periodo',
        inbound: 'In ingresso',
        outbound: 'In uscita',
        contacts: 'Contatti',
        leads: 'Lead',
        appointments: 'Appuntamenti',
        avgResponse: 'Tempo medio risposta',
        completed: 'Appuntamenti completati'
      }
    },
    settings: {
      title: 'Impostazioni · Utenti',
      subtitle: 'Gestisci gli accessi al workspace.',
      users: {
        title: 'Utenti',
        loading: 'Caricamento…',
        adminOnly: 'Solo gli amministratori possono accedere a questa pagina.',
        email: 'Email',
        name: 'Nome',
        role: 'Ruolo',
        lastLogin: 'Ultimo accesso',
        actions: 'Azioni',
        resetPassword: 'Reimposta password',
        resetPasswordSending: 'Invio…',
        delete: 'Elimina',
        deleteRemoving: 'Rimozione…'
      },
      invite: {
        title: 'Invita nuovo utente',
        email: 'Email',
        emailPlaceholder: 'Email',
        fullName: 'Nome completo',
        fullNamePlaceholder: 'Nome completo',
        role: 'Ruolo',
        temporaryPassword: 'Password temporanea',
        temporaryPasswordPlaceholder: 'Password temporanea',
        sendEmail: 'Invia email di invito (l\'utente definisce la password)',
        passwordInstructions: 'Un\'email chiederà all\'utente di scegliere la propria password.',
        passwordManual: 'Condividi questa password manualmente. Nessuna email verrà inviata.',
        inviteButton: 'Invita'
      },
      roleOptions: {
        owner: 'owner',
        admin: 'admin',
        agent: 'agent',
        viewer: 'viewer'
      }
    },
    detail: {
      contact: {
        timeline: 'Cronologia attività',
        newNote: 'Aggiungi nota',
        placeholder: 'Aggiungi una nota...',
        save: 'Salva nota'
      },
      lead: {
        contactCard: 'Contatto collegato',
        timeline: 'Cronologia attività',
        newNote: 'Aggiungi nota',
        placeholder: 'Aggiungi una nota...',
        save: 'Salva nota'
      }
    },
    prospezione: {
      title: 'Prospezione',
      subtitle: 'Gestisci la tua lista di contatti da visitare',
      noContacts: 'Nessun contatto',
      createCheckup: 'Crea Check-up',
      createCheckupTitle: 'Crea Check-up',
      createCheckupMessage: 'Creerai un Lead e un Appuntamento per questo contatto. Vuoi procedere?',
      createCheckupConfirm: 'Crea Check-up',
      createCheckupCancel: 'Annulla',
      details: 'Dettagli',
      openMaps: 'Apri su Maps',
      noName: 'Senza nome',
      stages: {
        new: 'Nuovo',
        to_visit: 'Da Visitare',
        visited_interested: 'Visitato - Interessato',
        visited_not_interested: 'Visitato - Non Interessato',
        nurture: 'Da Ricontattare',
        disqualified: 'Disqualificato'
      },
      activity: {
        coldVisit: 'Visita a freddo'
      },
      kpi: {
        totalProspects: 'Prospect Totali',
        conversionRate: 'Tasso di Conversione',
        visits: 'Visite',
        followUpDue: 'Follow-up da Fare',
        distributed: 'Distribuiti',
        interestedOutOf: '{{interested}} interessati su {{total}} totali',
        completed: 'Completate',
        toVisit: 'Da visitare',
        allUpToDate: 'Tutto aggiornato!'
      }
    },
    navigator: {
      title: 'Navigatore',
      subtitle: 'Seleziona fino a 10 contatti e visualizza il percorso ottimizzato',
      addContact: 'Aggiungi Contatto',
      selectContact: 'Seleziona Contatto',
      selectedContacts: 'Contatti Selezionati',
      noContactsSelected: 'Nessun contatto selezionato',
      selectContactsHint: 'Clicca su "Aggiungi Contatto" per iniziare',
      generateRoute: 'Genera Percorso',
      navigate: 'Naviga',
      clear: 'Pulisci',
      remove: 'Rimuovi',
      maxReached: 'Hai raggiunto il limite massimo di 10 contatti',
      noValidPoints: 'Nessun punto valido con coordinate',
      noAvailableContacts: 'Nessun contatto disponibile con Google Maps URL',
      noName: 'Senza nome'
    }
  },
  en: {
    navigation: {
      brand: 'Sales Navigator',
      contacts: 'Contacts',
      leads: 'Leads',
      prospezione: 'Prospecting',
      navigator: 'Navigator',
      appointments: 'Appointments',
      reports: 'Reports',
      settings: 'Settings · Users',
      logout: 'Logout'
    },
    common: {
      loading: 'Loading…',
      searchPlaceholder: 'Search name/email/phone',
      filterSource: 'Source',
      filterTag: 'Tag',
      filterStage: 'Type',
      sortRecent: 'Most recent',
      sortName: 'Sort by name',
      buttons: {
        new: 'New',
        create: 'Create',
        save: 'Save',
        edit: 'Edit',
        delete: 'Delete',
        cancel: 'Cancel',
        close: 'Close'
      },
      stages: {
        contact: 'Contact',
        lead: 'Lead',
        client: 'Client'
      },
      relative: {
        today: 'today',
        yesterday: 'yesterday',
        daysAgo: '{{count}}d ago'
      },
      openLeadBadge: '{{count}} lead',
      selected: '{{count}} selected'
    },
    contacts: {
      title: 'Contacts',
      subtitle: 'Manage records and monitor activity & duplicates.',
      newButton: 'New contact',
      summary: '{{count}} results · email duplicates: {{duplicateEmails}} · phone duplicates: {{duplicatePhones}}',
      columns: {
        name: 'Name',
        company: 'Company Name',
        email: 'Email',
        phone: 'Phone',
        source: 'Source',
        stage: 'Stage',
        address: 'Address',
        city: 'City',
        prospectStatus: 'Prospect Status',
        leadStatus: 'Lead Status',
        tags: 'Tags',
        interest_level: 'Interest Level',
        route_index: 'Route Index',
        vat: 'VAT',
        rank: 'Rank',
        lastActivity: 'Last Activity',
        website: 'Website',
        googleMaps: 'Google Maps',
        actions: 'Actions'
      },
      noTag: '—',
      noRank: 'Not set',
      duplicateBadge: 'dup',
      addToNavigator: 'Add to Navigator',
      alreadyInNavigator: 'Already in Navigator',
      addedToNavigator: 'Contact added to Navigator',
      drawer: {
        newTitle: 'New contact',
        editTitle: 'Edit contact',
        fullName: 'Full name',
        email: 'Email',
        phone: 'Phone',
        source: 'Source',
        tags: 'Tags (comma separated)',
        vat: 'VAT number',
        rank: 'Client rank',
        rankPlaceholder: 'Not set',
        stage: 'Type',
        typeLabel: 'Type',
        leadStatusLabel: 'Lead Status',
        prospectStatusLabel: 'Prospect Status',
        contactTypeOption: 'Contact',
        leadTypeOption: 'Lead',
        prospectTypeOption: 'Prospect'
      },
      delete: {
        title: 'Delete contact',
        message: 'Are you sure you want to delete {{name}}? This action cannot be undone.',
        confirm: 'Delete',
        cancel: 'Cancel'
      }
    },
    leads: {
      title: 'Leads',
      subtitle: 'Track pipeline, metrics and follow-ups.',
      newLead: 'New lead',
      na: 'N/A',
      searchPlaceholder: 'Search by title or contact',
      filters: {
        stage: 'Stage',
        duplicates: 'Possible duplicates'
      },
      defaults: {
        untitled: 'Untitled lead',
        fallbackTitle: 'Lead',
        noName: 'No name',
        linkedContact: 'Linked contact'
      },
      kpi: {
        totalContacts: 'Total contacts',
        totalLeads: 'Total leads',
        scheduled: 'Scheduled appointments',
        completed: 'Completed appointments',
        noShow: 'No-shows',
        conversion: 'Conversion rate',
        conversionDetail: '{{won}} won out of {{total}}'
      },
      pipelineSummary: 'Breakdown: {{breakdown}}',
      kpiSummary: 'Completed: {{completed}} · No-shows: {{noShow}}',
      pipeline: {
        headings: {
          new: 'New',
          qualified: 'Qualified',
          scheduled: 'Scheduled',
          won: 'Won',
          lost: 'Lost'
        },
        empty: 'Drag leads here to update their stage',
        staleBadge: 'follow-up',
        duplicateBadge: 'dup',
        duplicateMessage: 'Possible duplicate in the pipeline',
        unassigned: 'Contact not linked',
        lastUpdate: 'Last update',
        source: 'Source',
        emptyColumn: 'No leads in this column.'
      },
      followUps: {
        title: 'Follow-ups due',
        empty: 'All clear!'
      },
      modal: {
        newTitle: 'Create lead',
        editTitle: 'Edit lead',
        titleLabel: 'Title',
        valueLabel: 'Value (EUR)',
        stageLabel: 'Stage',
        selectContact: 'Select contact',
        newContactHeading: 'Create new contact',
        contactName: 'Name',
        contactPhone: 'Phone',
        contactEmail: 'Email',
        notes: 'Internal notes',
        notesPlaceholder: 'Add notes, details or relevant information about the lead...',
        attachedContact: 'Linked contact',
        addLead: 'Create lead',
        saveLead: 'Save',
        cancel: 'Cancel',
        deleteTitle: 'Delete lead',
        deleteText: 'Do you really want to delete {{title}}? This action cannot be undone.',
        details: 'Details',
        linkContact: 'Link contact',
        singleMode: 'Single mode',
        multiMode: 'Multi mode',
        contactDetailsNote: 'Contact details are modified from the contact card.',
        orCreateNew: '…or create a new contact',
        remove: 'Remove',
        loading: 'Loading…',
        selected: 'selected'
      }
    },
    appointments: {
      title: 'Scheduling & appointments',
      subtitle: 'Scheduling & Appointments',
      description: 'Manage slots, bookings and automatic reminders.',
      calendarSync: {
        title: 'Calendar sync',
        heading: 'Connect your calendar',
        description: 'Store the calendar link (ICS or CalDAV) to keep Launch appointments aligned with your personal schedule.',
        status: 'Status',
        edit: 'Edit',
        displayName: 'Display name',
        displayNamePlaceholder: 'e.g. Victor – Outlook',
        provider: 'Provider',
        providerManual: 'Manual (ICS link)',
        providerMicrosoft: 'Microsoft 365',
        providerCalendly: 'Calendly',
        icsLink: 'ICS / booking link',
        icsLinkPlaceholder: 'https://...',
        saveConnection: 'Save connection'
      },
      buildAvailability: {
        title: 'Build availability',
        description: 'Add time slots that the system can book automatically when leads pick a time.',
        startDateTime: 'Start date & time',
        duration: 'Duration (minutes)',
        calendar: 'Calendar',
        internalNotes: 'Internal notes',
        internalNotesPlaceholder: 'Optional details for the team',
        addSlot: 'Add slot'
      },
      availableSlots: {
        title: 'Available slots',
        subtitle: 'Ready to book',
        empty: 'No availability yet. Add a slot on the left to make booking windows available.',
        open: '{{count}} open',
        book: 'Book',
        cancel: 'Cancel'
      },
      bookedSlots: {
        title: 'Booked slots'
      },
      upcoming: {
        title: 'Upcoming appointments',
        subtitle: 'Next 20 bookings',
        scheduled: '{{count}} scheduled',
        empty: 'When an available slot is booked, it will appear here with contact details and status.',
        when: 'When',
        contact: 'Contact',
        subject: 'Title',
        status: 'Status',
        actions: 'Actions',
        join: 'Join',
        done: 'Done',
        cancel: 'Cancel'
      },
      modal: {
        bookTitle: 'Book slot',
        existingContact: 'Existing contact',
        selectContact: 'Select contact…',
        orCreateNew: 'Or create new',
        fullName: 'Full name',
        phone: 'Phone',
        phonePlaceholder: '+39 333…',
        email: 'Email (optional)',
        emailPlaceholder: 'client@example.com',
        title: 'Title',
        titlePlaceholder: 'Consultation call',
        notes: 'Notes',
        notesPlaceholder: 'Brief agenda',
        cancel: 'Cancel',
        confirmBooking: 'Confirm booking'
      },
      errors: {
        loadData: 'Unable to load scheduling data',
        createSlot: 'Unable to create slot',
        cancelSlot: 'Unable to cancel slot',
        bookAppointment: 'Unable to book appointment',
        updateAppointment: 'Unable to update appointment',
        deleteAppointment: 'Unable to delete appointment',
        deleteSlot: 'Unable to delete slot',
        saveConnection: 'Unable to save calendar connection',
        selectContact: 'Select an existing contact or provide details for a new one.',
        contactCreationFailed: 'Contact creation failed'
      },
      loading: 'Loading scheduling data…',
      delete: {
        title: 'Delete appointment',
        confirm: 'Are you sure you want to delete this appointment? This action cannot be undone.',
        button: 'Delete'
      },
      deleteSlot: {
        title: 'Delete slot',
        confirm: 'Are you sure you want to delete this booked slot? The associated appointment will also be deleted if present. This action cannot be undone.'
      }
    },
    reports: {
      title: 'Reports',
      subtitle: 'KPI overview and conversation trends.',
      loading: 'Loading metrics…',
      empty: 'No KPI data available yet. Interactions captured via WhatsApp, contacts and appointments will appear here automatically.',
      cards: {
        inboundMessages: 'Inbound messages',
        contactsCaptured: 'Contacts captured',
        leadsCreated: 'Leads created',
        appointmentsCompleted: 'Appointments completed',
        avgFirstResponse: 'Avg first response',
        vsPrevious: 'vs previous'
      },
      charts: {
        messagingVolume: 'Messaging volume',
        pipelineVelocity: 'Pipeline velocity'
      },
      table: {
        date: 'Date',
        period: 'Period',
        inbound: 'Inbound',
        outbound: 'Outbound',
        contacts: 'Contacts',
        leads: 'Leads',
        appointments: 'Appointments',
        avgResponse: 'Avg response',
        completed: 'Completed appointments'
      }
    },
    settings: {
      title: 'Settings · Users',
      subtitle: 'Manage workspace access.',
      users: {
        title: 'Users',
        loading: 'Loading…',
        adminOnly: 'Only admins can access this page.',
        email: 'Email',
        name: 'Name',
        role: 'Role',
        lastLogin: 'Last login',
        actions: 'Actions',
        resetPassword: 'Reset password',
        resetPasswordSending: 'Sending…',
        delete: 'Delete',
        deleteRemoving: 'Removing…'
      },
      invite: {
        title: 'Invite new user',
        email: 'Email',
        emailPlaceholder: 'Email',
        fullName: 'Full name',
        fullNamePlaceholder: 'Full name',
        role: 'Role',
        temporaryPassword: 'Temporary password',
        temporaryPasswordPlaceholder: 'Temporary password',
        sendEmail: 'Send invite email (user defines password)',
        passwordInstructions: 'An email will ask the user to choose their own password.',
        passwordManual: 'Share this password manually. No email will be sent.',
        inviteButton: 'Invite'
      },
      roleOptions: {
        owner: 'owner',
        admin: 'admin',
        agent: 'agent',
        viewer: 'viewer'
      }
    },
    detail: {
      contact: {
        timeline: 'Activity timeline',
        newNote: 'Add note',
        placeholder: 'Add a note…',
        save: 'Save note'
      },
      lead: {
        contactCard: 'Linked contact',
        timeline: 'Activity timeline',
        newNote: 'Add note',
        placeholder: 'Add a note…',
        save: 'Save note'
      }
    },
    prospezione: {
      title: 'Prospecting',
      subtitle: 'Manage your list of contacts to visit',
      noContacts: 'No contacts',
      createCheckup: 'Create Check-up',
      createCheckupTitle: 'Create Check-up',
      createCheckupMessage: 'You will create a Lead and an Appointment for this contact. Do you want to proceed?',
      createCheckupConfirm: 'Create Check-up',
      createCheckupCancel: 'Cancel',
      details: 'Details',
      openMaps: 'Open on Maps',
      noName: 'No name',
      stages: {
        new: 'New',
        to_visit: 'To Visit',
        visited_interested: 'Visited - Interested',
        visited_not_interested: 'Visited - Not Interested',
        nurture: 'To Recontact',
        disqualified: 'Disqualified'
      },
      activity: {
        coldVisit: 'Cold visit'
      },
      kpi: {
        totalProspects: 'Total Prospects',
        conversionRate: 'Conversion Rate',
        visits: 'Visits',
        followUpDue: 'Follow-up Due',
        distributed: 'Distributed',
        interestedOutOf: '{{interested}} interested out of {{total}}',
        completed: 'Completed',
        toVisit: 'To visit',
        allUpToDate: 'All up to date!'
      }
    },
    navigator: {
      title: 'Navigator',
      subtitle: 'Select up to 10 contacts and view optimized route',
      addContact: 'Add Contact',
      selectContact: 'Select Contact',
      selectedContacts: 'Selected Contacts',
      noContactsSelected: 'No contacts selected',
      selectContactsHint: 'Click "Add Contact" to get started',
      generateRoute: 'Generate Route',
      navigate: 'Navigate',
      clear: 'Clear',
      remove: 'Remove',
      maxReached: 'You have reached the maximum limit of 10 contacts',
      noValidPoints: 'No valid points with coordinates',
      noAvailableContacts: 'No contacts available with Google Maps URL',
      noName: 'No name'
    }
  }
};

